import http from './utils';
import { prefix } from './constants';

type TApiFunction<TPayload = any, TResponse = any> = (
  payload: TPayload,
) => Promise<TResponse>;

/**
 * 获取 Memes 列表数据
 * POST /api/v1/marketing/memes/list
 */
export const getMemesTableList: TApiFunction = payload => {
  return http({
    url: `${prefix}/memes/list`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
};

/**
 * 获取 Meme 详情
 */
export const getMemeDetails: TApiFunction = payload => {
  return http({
    url: `${prefix}/memes/details`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
};

/**
 * 获取 Meme 趋势时间线
 * POST /api/v1/marketing/memes/trend
 */
export const getMemeTrendTimeline: TApiFunction = payload => {
  return http({
    url: `${prefix}/memes/trend`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
};

/**
 * 获取 Meme 语言分布
 */
export const getMemeLanguageDistribution: TApiFunction = payload => {
  return http({
    url: `${prefix}/memes/language_distribution`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
};

/**
 * 获取 Meme KOL 列表
 */
export const getMemeDetailsKolList: TApiFunction = payload => {
  return http({
    url: `${prefix}/memes/kol_list`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
};

/**
 * 获取 Meme 视频列表
 */
export const getMemeDetailsVideoList: TApiFunction = payload => {
  return http({
    url: `${prefix}/memes/video_list`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
};
